import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { transferServiceSchema, TransferServiceForm } from "../../schemas/transferServiceSchema";
import { useEffect, useMemo, useState } from "react";
import { useApiProvider } from "../../providers/api/apiProvider";

import { Service } from "../../models/Service";
import { Queue } from "../../models/Queue";
import { getAllQueues, GetAllQueuesPayload } from "../../services/queueServices";

export const useTransferServiceModalController = ( service: Service | null, open: boolean, onClose: () => void, onTransfer: ( queueId?: string, comment?: string ) => Promise<boolean | void> | boolean | void ) => {
  const {
    simpleApiCall,
  } = useApiProvider();

  const [ queues, setQueues ] = useState<Array<Queue>>([]);

  const form = useForm<TransferServiceForm>({
    resolver: yupResolver( transferServiceSchema ),
    defaultValues: {
      serviceId: "",
      queueId: "",
      comment: "",
    },
    mode: 'all',
  });

  const loadQueues = async () => {
    const response = await simpleApiCall<GetAllQueuesPayload, Array<Queue>>( getAllQueues, undefined );

    if( response !== null ) {
      setQueues( response );

      const selectedQueueId = service?.queue?.id || response[ 0 ]?.id || "";
      if( selectedQueueId ) form.setValue("queueId", selectedQueueId, {
        shouldValidate: true,
      });
    }
  };

  const onSubmit = async ( data: TransferServiceForm ) => {
    const transferred = await onTransfer( data.queueId, data.comment ?? "" );

    if( transferred !== false ) onClose();
  };

  const handleSubmit = form.handleSubmit( onSubmit );

  useEffect(() => {
    if( !open ) {
      form.reset();
    } else if( service !== null ) {
      form.setValue("serviceId", service.id, {
        shouldValidate: true,
      });

      loadQueues();
    }
    // eslint-disable-next-line
  }, [ open ]);

  return useMemo(() => ({
    form,
    queues,
    handleSubmit,
    // eslint-disable-next-line
  }), [
    form,
    queues,
  ]);
};
